import { render, staticRenderFns } from "./PatientForm.vue?vue&type=template&id=490127e2&scoped=true"
import script from "./PatientForm.vue?vue&type=script&lang=js"
export * from "./PatientForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "490127e2",
  null
  
)

export default component.exports